function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Controller } from 'stimulus';
import CableReady from 'cable_ready';
import { defaultSchema } from './schema';
import { getConsumer } from './consumer';
import { dispatchLifecycleEvent } from './lifecycle';
import { allReflexControllers } from './controllers';
import { uuidv4, debounce, emitEvent, serializeForm } from './utils';
import Log from './log';
import Debug from './debug';
import { attributeValue, attributeValues, extractElementAttributes, extractElementDataset } from './attributes';
import { extractReflexName, elementToXPath, XPathToElement } from './utils';

// A lambda that does nothing. Very zen; we are made of stars
var NOOP = function NOOP() {};

// A reference to the Stimulus application registered with: StimulusReflex.initialize
var stimulusApplication;

// A reference to the ActionCable consumer registered with: StimulusReflex.initialize or getConsumer
var actionCableConsumer;

// A reference to an optional object called params defined in the StimulusReflex.initialize and passed to channels
var actionCableParams;

// Flag which will be false if the server does not accept the channel subscription
var actionCableSubscriptionActive = false;

// A dictionary of all active Reflex operations, indexed by reflexId
window.reflexes = {};

// Should Reflex playback be restricted to the tab that called it?
var isolationMode;

// Subscribes a StimulusReflex controller to an ActionCable channel.
// controller - the StimulusReflex controller to subscribe
//
var createSubscription = function createSubscription(controller) {
  actionCableConsumer = actionCableConsumer || getConsumer();
  var channel = controller.StimulusReflex.channel;
  var subscription = _objectSpread({
    channel: channel
  }, actionCableParams);
  var identifier = JSON.stringify(subscription);
  controller.StimulusReflex.subscription = actionCableConsumer.subscriptions.findAll(identifier)[0] || actionCableConsumer.subscriptions.create(subscription, {
    received: function received(data) {
      if (!data.cableReady) return;
      var reflexOperations = {};
      for (var name in data.operations) {
        if (data.operations.hasOwnProperty(name)) {
          for (var i = data.operations[name].length - 1; i >= 0; i--) {
            if (data.operations[name][i].stimulusReflex || data.operations[name][i].detail && data.operations[name][i].detail.stimulusReflex) {
              reflexOperations[name] = reflexOperations[name] || [];
              reflexOperations[name].push(data.operations[name][i]);
              data.operations[name].splice(i, 1);
            }
          }
          if (!data.operations[name].length) Reflect.deleteProperty(data.operations, name);
        }
      }
      var totalOperations = 0;
      var reflexData;
      var dispatchEvent = reflexOperations['dispatchEvent'];
      var morph = reflexOperations['morph'];
      var innerHtml = reflexOperations['innerHtml'];
      [dispatchEvent, morph, innerHtml].forEach(function (operation) {
        if (operation && operation.length) {
          var urls = Array.from(new Set(operation.map(function (m) {
            return m.detail ? m.detail.stimulusReflex.url : m.stimulusReflex.url;
          })));
          if (urls.length !== 1 || urls[0] !== location.href) return;
          totalOperations += operation.length;
          if (!reflexData) {
            reflexData = operation[0].detail ? operation[0].detail.stimulusReflex : operation[0].stimulusReflex;
          }
        }
      });
      if (reflexData) {
        var _reflexData = reflexData,
          reflexId = _reflexData.reflexId;
        if (!reflexes[reflexId] && !isolationMode) {
          var controllerElement = XPathToElement(reflexData.xpathController);
          var reflexElement = XPathToElement(reflexData.xpathElement);
          controllerElement.reflexController = controllerElement.reflexController || {};
          controllerElement.reflexData = controllerElement.reflexData || {};
          controllerElement.reflexError = controllerElement.reflexError || {};
          controllerElement.reflexController[reflexId] = stimulusApplication.getControllerForElementAndIdentifier(controllerElement, reflexData.reflexController);
          controllerElement.reflexData[reflexId] = reflexData;
          dispatchLifecycleEvent('before', reflexElement, controllerElement, reflexId);
          registerReflex(reflexData);
        }
        if (reflexes[reflexId]) {
          reflexes[reflexId].totalOperations = totalOperations;
          reflexes[reflexId].pendingOperations = totalOperations;
          reflexes[reflexId].completedOperations = 0;
          CableReady.perform(reflexOperations);
        }
      }

      // run piggy back operations after stimulus reflex behavior
      CableReady.perform(data.operations);
    },
    connected: function connected() {
      actionCableSubscriptionActive = true;
      emitEvent('stimulus-reflex:connected');
    },
    rejected: function rejected() {
      actionCableSubscriptionActive = false;
      emitEvent('stimulus-reflex:rejected');
      if (Debug.enabled) console.warn('Channel subscription was rejected.');
    },
    disconnected: function disconnected(willAttemptReconnect) {
      actionCableSubscriptionActive = false;
      emitEvent('stimulus-reflex:disconnected', willAttemptReconnect);
    }
  });
};

// Extends a regular Stimulus controller with StimulusReflex behavior.
//
// Methods added to the Stimulus controller:
// - stimulate
// - __perform
//
var extendStimulusController = function extendStimulusController(controller) {
  Object.assign(controller, {
    // Indicates if the ActionCable web socket connection is open.
    // The connection must be open before calling stimulate.
    //
    isActionCableConnectionOpen: function isActionCableConnectionOpen() {
      return this.StimulusReflex.subscription.consumer.connection.isOpen();
    },
    // Invokes a server side reflex method.
    //
    // - target - the reflex target (full name of the server side reflex) i.e. 'ReflexClassName#method'
    // - controllerElement - [optional] the element that triggered the reflex, defaults to this.element
    // - options - [optional] an object that contains at least one of attrs, reflexId, selectors, resolveLate, serializeForm
    // - *args - remaining arguments are forwarded to the server side reflex method
    //
    stimulate: function stimulate() {
      var url = location.href;
      var args = Array.from(arguments);
      var target = args.shift() || 'StimulusReflex::Reflex#default_reflex';
      var controllerElement = this.element;
      var reflexElement = args[0] && args[0].nodeType === Node.ELEMENT_NODE ? args.shift() : controllerElement;
      if (reflexElement.type === 'number' && reflexElement.validity && reflexElement.validity.badInput) {
        if (Debug.enabled) console.warn('Reflex aborted: invalid numeric input');
        return;
      }
      var options = {};
      if (args[0] && _typeof(args[0]) === 'object' && Object.keys(args[0]).filter(function (key) {
        return ['attrs', 'selectors', 'reflexId', 'resolveLate', 'serializeForm'].includes(key);
      }).length) {
        var opts = args.shift();
        Object.keys(opts).forEach(function (o) {
          return options[o] = opts[o];
        });
      }
      var attrs = options['attrs'] || extractElementAttributes(reflexElement);
      var reflexId = options['reflexId'] || uuidv4();
      var selectors = options['selectors'] || getReflexRoots(reflexElement);
      if (typeof selectors === 'string') selectors = [selectors];
      var resolveLate = options['resolveLate'] || false;
      var datasetAttribute = stimulusApplication.schema.reflexDatasetAttribute;
      var dataset = extractElementDataset(reflexElement, datasetAttribute);
      var xpathController = elementToXPath(controllerElement);
      var xpathElement = elementToXPath(reflexElement);
      var data = {
        target: target,
        args: args,
        url: url,
        attrs: attrs,
        dataset: dataset,
        selectors: selectors,
        reflexId: reflexId,
        resolveLate: resolveLate,
        xpathController: xpathController,
        xpathElement: xpathElement,
        reflexController: this.identifier,
        permanentAttributeName: stimulusApplication.schema.reflexPermanentAttribute
      };
      var subscription = this.StimulusReflex.subscription;
      if (!this.isActionCableConnectionOpen()) throw 'The ActionCable connection is not open! `this.isActionCableConnectionOpen()` must return true before calling `this.stimulate()`';
      if (!actionCableSubscriptionActive) throw 'The ActionCable channel subscription for StimulusReflex was rejected.';

      // lifecycle setup
      controllerElement.reflexController = controllerElement.reflexController || {};
      controllerElement.reflexData = controllerElement.reflexData || {};
      controllerElement.reflexError = controllerElement.reflexError || {};
      controllerElement.reflexController[reflexId] = this;
      controllerElement.reflexData[reflexId] = data;
      dispatchLifecycleEvent('before', reflexElement, controllerElement, reflexId);
      setTimeout(function () {
        var _ref = controllerElement.reflexData[reflexId] || {},
          params = _ref.params;
        var formData = options['serializeForm'] === false ? '' : serializeForm(reflexElement.closest('form'), {
          element: reflexElement
        });
        controllerElement.reflexData[reflexId] = _objectSpread(_objectSpread({}, data), {}, {
          params: params,
          formData: formData
        });
        subscription.send(controllerElement.reflexData[reflexId]);
      });
      var promise = registerReflex(data);
      if (Debug.enabled) {
        Log.request(reflexId, target, args, this.context.scope.identifier, reflexElement, controllerElement);
      }
      return promise;
    },
    // Wraps the call to stimulate for any data-reflex elements.
    // This is internal and should not be invoked directly.
    __perform: function __perform(event) {
      var element = event.target;
      var reflex;
      while (element && !reflex) {
        reflex = element.getAttribute(stimulusApplication.schema.reflexAttribute);
        if (!reflex || !reflex.trim().length) element = element.parentElement;
      }
      var match = attributeValues(reflex).find(function (reflex) {
        return reflex.split('->')[0] === event.type;
      });
      if (match) {
        event.preventDefault();
        event.stopPropagation();
        this.stimulate(match.split('->')[1], element);
      }
    }
  });
};
var registerReflex = function registerReflex(data) {
  var reflexId = data.reflexId;
  reflexes[reflexId] = {
    finalStage: 'finalize'
  };
  var promise = new Promise(function (resolve, reject) {
    reflexes[reflexId].promise = {
      resolve: resolve,
      reject: reject,
      data: data
    };
  });
  promise.reflexId = reflexId;
  if (Debug.enabled) promise.catch(NOOP);
  return promise;
};

// Registers a Stimulus controller and extends it with StimulusReflex behavior
//
// controller - the Stimulus controller
// options - [optional] configuration
//
var register = function register(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var channel = 'StimulusReflex::Channel';
  controller.StimulusReflex = _objectSpread(_objectSpread({}, options), {}, {
    channel: channel
  });
  createSubscription(controller);
  extendStimulusController(controller);
};

// Default StimulusReflexController that is implicitly wired up as data-controller for any DOM elements
// that have configured data-reflex. Note that this default can be overridden when initializing the application.
// i.e. StimulusReflex.initialize(myStimulusApplication, MyCustomDefaultController);
//
var StimulusReflexController = /*#__PURE__*/function (_Controller) {
  _inherits(StimulusReflexController, _Controller);
  var _super = _createSuper(StimulusReflexController);
  function StimulusReflexController() {
    var _this;
    _classCallCheck(this, StimulusReflexController);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    register(_assertThisInitialized(_this));
    return _this;
  }
  return StimulusReflexController;
}(Controller); // Sets up declarative reflex behavior.
// Any elements that define data-reflex will automatically be wired up with the default StimulusReflexController.
//
var setupDeclarativeReflexes = debounce(function () {
  document.querySelectorAll("[".concat(stimulusApplication.schema.reflexAttribute, "]")).forEach(function (element) {
    var controllers = attributeValues(element.getAttribute(stimulusApplication.schema.controllerAttribute));
    var reflexAttributeNames = attributeValues(element.getAttribute(stimulusApplication.schema.reflexAttribute));
    var actions = attributeValues(element.getAttribute(stimulusApplication.schema.actionAttribute));
    reflexAttributeNames.forEach(function (reflexName) {
      var controller = findControllerByReflexName(reflexName, allReflexControllers(stimulusApplication, element));
      var action;
      if (controller) {
        action = "".concat(reflexName.split('->')[0], "->").concat(controller.identifier, "#__perform");
        if (!actions.includes(action)) actions.push(action);
      } else {
        action = "".concat(reflexName.split('->')[0], "->stimulus-reflex#__perform");
        if (!controllers.includes('stimulus-reflex')) {
          controllers.push('stimulus-reflex');
        }
        if (!actions.includes(action)) actions.push(action);
      }
    });
    var controllerValue = attributeValue(controllers);
    var actionValue = attributeValue(actions);
    if (controllerValue && element.getAttribute(stimulusApplication.schema.controllerAttribute) != controllerValue) {
      element.setAttribute(stimulusApplication.schema.controllerAttribute, controllerValue);
    }
    if (actionValue && element.getAttribute(stimulusApplication.schema.actionAttribute) != actionValue) element.setAttribute(stimulusApplication.schema.actionAttribute, actionValue);
  });
  emitEvent('stimulus-reflex:ready');
}, 20);

// Given a reflex string such as 'click->TestReflex#create' and a list of
// controllers. It will find the matching controller based on the controller's
// identifier. e.g. Given these controller identifiers ['foo', 'bar', 'test'],
// it would select the 'test' controller.
var findControllerByReflexName = function findControllerByReflexName(reflexName, controllers) {
  var controller = controllers.find(function (controller) {
    if (!controller.identifier) return;
    return extractReflexName(reflexName).toLowerCase() === controller.identifier.toLowerCase();
  });
  return controller || controllers[0];
};

// compute the DOM element(s) which will be the morph root
// use the data-reflex-root attribute on the reflex or the controller
// optional value is a CSS selector(s); comma-separated list
// order of preference is data-reflex, data-controller, document body (default)
var getReflexRoots = function getReflexRoots(element) {
  var list = [];
  while (list.length === 0 && element) {
    var reflexRoot = element.getAttribute(stimulusApplication.schema.reflexRootAttribute);
    if (reflexRoot) {
      if (reflexRoot.length === 0 && element.id) reflexRoot = "#".concat(element.id);
      var selectors = reflexRoot.split(',').filter(function (s) {
        return s.trim().length;
      });
      if (selectors.length === 0) {
        console.error("No value found for ".concat(stimulusApplication.schema.reflexRootAttribute, ". Add an #id to the element or provide a value for ").concat(stimulusApplication.schema.reflexRootAttribute, "."), element);
      }
      list = list.concat(selectors.filter(function (s) {
        return document.querySelector(s);
      }));
    }
    element = element.parentElement ? element.parentElement.closest("[".concat(stimulusApplication.schema.reflexRootAttribute, "]")) : null;
  }
  return list;
};

// Initializes StimulusReflex by registering the default Stimulus controller with the passed Stimulus application.
//
// - application - the Stimulus application
// - options
//   * controller - [optional] the default StimulusReflexController
//   * consumer - [optional] the ActionCable consumer
//   * debug - [false] log all Reflexes to the console
//   * params - [{}] key/value parameters to send during channel subscription
//   * isolate - [false] restrict Reflex playback to the tab which initiated it
//
var initialize = function initialize(application) {
  var initializeOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var controller = initializeOptions.controller,
    consumer = initializeOptions.consumer,
    debug = initializeOptions.debug,
    params = initializeOptions.params,
    isolate = initializeOptions.isolate;
  actionCableConsumer = consumer;
  actionCableParams = params;
  isolationMode = !!isolate;
  stimulusApplication = application;
  stimulusApplication.schema = _objectSpread(_objectSpread({}, defaultSchema), application.schema);
  stimulusApplication.register('stimulus-reflex', controller || StimulusReflexController);
  Debug.set(!!debug);
};
if (!document.stimulusReflexInitialized) {
  document.stimulusReflexInitialized = true;
  window.addEventListener('load', function () {
    setupDeclarativeReflexes();
    var observer = new MutationObserver(setupDeclarativeReflexes);
    observer.observe(document.documentElement, {
      attributes: true,
      childList: true,
      subtree: true
    });
  });
  var beforeDOMUpdate = function beforeDOMUpdate(event) {
    var _ref2 = event.detail || {},
      stimulusReflex = _ref2.stimulusReflex;
    if (!stimulusReflex) return;
    var reflexId = stimulusReflex.reflexId,
      xpathElement = stimulusReflex.xpathElement,
      xpathController = stimulusReflex.xpathController;
    var controllerElement = XPathToElement(xpathController);
    var reflexElement = XPathToElement(xpathElement);
    var reflex = reflexes[reflexId];
    var promise = reflex.promise;
    reflex.pendingOperations--;
    if (reflex.pendingOperations > 0) return;
    if (!stimulusReflex.resolveLate) setTimeout(function () {
      return promise.resolve({
        element: reflexElement,
        event: event,
        data: promise.data
      });
    });
    setTimeout(function () {
      return dispatchLifecycleEvent('success', reflexElement, controllerElement, reflexId);
    });
  };
  document.addEventListener('cable-ready:before-inner-html', beforeDOMUpdate);
  document.addEventListener('cable-ready:before-morph', beforeDOMUpdate);
  var afterDOMUpdate = function afterDOMUpdate(event) {
    var _ref3 = event.detail || {},
      stimulusReflex = _ref3.stimulusReflex;
    if (!stimulusReflex) return;
    var reflexId = stimulusReflex.reflexId,
      xpathElement = stimulusReflex.xpathElement,
      xpathController = stimulusReflex.xpathController;
    var controllerElement = XPathToElement(xpathController);
    var reflexElement = XPathToElement(xpathElement);
    var reflex = reflexes[reflexId];
    var promise = reflex.promise;
    reflex.completedOperations++;
    if (Debug.enabled) Log.success(event);
    if (reflex.completedOperations < reflex.totalOperations) return;
    if (stimulusReflex.resolveLate) setTimeout(function () {
      return promise.resolve({
        element: reflexElement,
        event: event,
        data: promise.data
      });
    });
    setTimeout(function () {
      return dispatchLifecycleEvent('finalize', reflexElement, controllerElement, reflexId);
    });
  };
  document.addEventListener('cable-ready:after-inner-html', afterDOMUpdate);
  document.addEventListener('cable-ready:after-morph', afterDOMUpdate);
  document.addEventListener('stimulus-reflex:server-message', function (event) {
    var _ref4 = event.detail.stimulusReflex || {},
      reflexId = _ref4.reflexId,
      serverMessage = _ref4.serverMessage,
      xpathController = _ref4.xpathController,
      xpathElement = _ref4.xpathElement;
    var subject = serverMessage.subject,
      body = serverMessage.body;
    var controllerElement = XPathToElement(xpathController);
    var reflexElement = XPathToElement(xpathElement);
    var promise = reflexes[reflexId].promise;
    var subjects = {
      error: true,
      halted: true,
      nothing: true,
      success: true
    };
    controllerElement.reflexError = controllerElement.reflexError || {};
    if (controllerElement && subject === 'error') controllerElement.reflexError[reflexId] = body;
    promise[subject === 'error' ? 'reject' : 'resolve']({
      data: promise.data,
      element: reflexElement,
      event: event,
      toString: function toString() {
        return body;
      }
    });
    reflexes[reflexId].finalStage = subject === 'halted' ? 'halted' : 'after';
    if (Debug.enabled) Log[subject === 'error' ? 'error' : 'success'](event);
    if (subjects[subject]) dispatchLifecycleEvent(subject, reflexElement, controllerElement, reflexId);
  });
}
export default {
  initialize: initialize,
  register: register,
  get debug() {
    return Debug.value;
  },
  set debug(value) {
    Debug.set(!!value);
  }
};